module.exports = __webpack_public_path__ + "static/media/supper.ed619746.png";